module.exports = __webpack_public_path__ + "static/images/offline.706fac6f.png";